import { isUpdaterFunction } from './common';
import { useState, useCallback } from 'react';
import { produce } from 'immer';
export const isInitializerFunction = initializer => {
  return typeof initializer === 'function';
};
export function useImmer(initializer) {
  const [val, updateValue] = useState(() => {
    const initialValue = isInitializerFunction(initializer) ? initializer() : initializer;
    return initialValue;
  });
  return [val, useCallback(updater => {
    if (isUpdaterFunction(updater)) {
      const draftedUpdater = produce(updater);
      updateValue(draftedUpdater);
    } else {
      updateValue(updater);
    }
  }, [])];
}